'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Log = require('../../shared/Log');

var _players = require('../../store/actions/players');

var dataHudlElement = 'vi-controls-backward';
var FIVE_SECONDS = 5000;
var iconName = 'backward5sec';
var title = 'vi.player.controls.backward';

function handleClick(playerId) {
  return function (dispatch, getState) {
    var timeToMoveTo = 0;
    var currentTimeMs = getState().players[playerId].currentTimeMs;
    if (currentTimeMs >= FIVE_SECONDS) {
      timeToMoveTo = currentTimeMs - FIVE_SECONDS;
    }
    (0, _Log.log)(playerId, 'Back5Sec');
    dispatch((0, _players.setCurrentTimeMs)(playerId, timeToMoveTo));
  };
}

function onClick(dispatch, ownProps, playerId) {
  dispatch(handleClick(playerId));
}

var mapStateToProps = function mapStateToProps() {
  return {
    title: title,
    iconName: iconName,
    dataHudlElement: dataHudlElement
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps, _ref) {
  var playerId = _ref.playerId;

  return {
    onClick: onClick.bind(null, dispatch, ownProps, playerId)
  };
};

exports.default = {
  mapStateToProps: mapStateToProps,
  mapDispatchToProps: mapDispatchToProps
};
module.exports = exports['default'];